<template>
    <v-layout row wrap class="pa-2">
        <v-flex xs12 md12 class="pl-4">
            <confirmation-header-text :text="$vuetify.lang.t('$vuetify.dependent_person_detail')"
                                      class="ml-0"
                                      icon="mdi-account-multiple"></confirmation-header-text>
        </v-flex>
        <v-flex xs12 sm4>
            <list-item-detail :sub_title="dependentVisaDetail.visa_number"
                              class="pl-0"
                              :title="$vuetify.lang.t('$vuetify.dependent_visa_number')">
            </list-item-detail>
        </v-flex>
        <v-flex xs12 sm4>
            <list-item-detail :sub_title="dependentVisaDetail.passport_number"

                              :title="$vuetify.lang.t('$vuetify.dependent_passport_number')">
            </list-item-detail>
        </v-flex>
        <v-flex xs12 sm4>
            <list-item-detail :sub_title="visa.extra.application_data.relation"
                              :title="$vuetify.lang.t('$vuetify.relation')">
            </list-item-detail>
        </v-flex>

        <v-flex xs12 sm4>
            <list-item-detail :sub_title="dependentVisaDetail && dependentVisaDetail.traveller.full_name"
                              :title="$vuetify.lang.t('$vuetify.full_name')">
            </list-item-detail>
        </v-flex>
        <v-flex xs12 sm4>
            <list-item-detail :sub_title="dependentVisaDetail && dependentVisaDetail.traveller.gender"
                              :title="$vuetify.lang.t('$vuetify.gender')">
            </list-item-detail>
        </v-flex>
        <v-flex xs12 sm4>
            <list-item-detail :sub_title="dependentVisaDetail&&dependentVisaDetail.traveller.contact_number"
                              :title="$vuetify.lang.t('$vuetify.contact_no')">
            </list-item-detail>
        </v-flex>
    </v-layout>

</template>

<script>
    import ListItemDetail from "../../ListItemDetail";
    import {mapGetters} from 'vuex'
    import ConfirmationHeaderText from "../../ConfirmationHeaderText";

    export default {
        components: {
            ListItemDetail,
            ConfirmationHeaderText
        },
        computed: {
            ...mapGetters('VisaSingle', ['extendConvertData', 'dependentVisaDetail', 'visa'])
        },
    };
</script>

<style>
</style>
